"use client";
import { createContext } from "react";
const WidthCapContext = createContext(void 0);
export { WidthCapContext };
